import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './brand.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker so PlanB Jobs can be installed as a PWA
// and load faster on repeat visits. This was previously unregister()
// by CRA default — Step 1 switches it to register().
// The onUpdate callback wires into Step 14 (update banner) later.
let refreshing = false;
const hadController = !!navigator.serviceWorker?.controller;
navigator.serviceWorker?.addEventListener('controllerchange', () => {
  if (!hadController || refreshing) return; // skip reload on first-ever visit
  refreshing = true;
  window.location.reload();
});

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    // Reload is now handled by the controllerchange listener above,
    // once the new SW is actually in control.
  },
  onSuccess: (registration) => {
    console.log('PlanB Jobs is ready for offline use.', registration);
  },
});